export namespace ADPolicyState {
	export const ENABLED: boolean = false;
	export const DISABLED: boolean = true;
	export const NOT_CONFIGURED = undefined
}
